import axios from '@/store/interceptor';
import apiUrl from '@/config/api.config';

// Callers show error.response.data.message (Romanian) and handle 409 CONFIRM_USED themselves
const get = async (url, params) => (await axios.get(`${apiUrl}${url}`, { params })).data;
const post = async (url, body) => (await axios.post(`${apiUrl}${url}`, body)).data;
const patch = async (url, body) => (await axios.patch(`${apiUrl}${url}`, body)).data;
const put = async (url, body) => (await axios.put(`${apiUrl}${url}`, body)).data;
const remove = async (url) => (await axios.delete(`${apiUrl}${url}`)).data;

// Equipment types
export const getCircuits = () => get('/config/circuits');
export const createCircuit = (body) => post('/config/circuits', body);
export const updateCircuit = (id, body) => patch(`/config/circuits/${id}`, body);
export const deleteCircuit = (id) => remove(`/config/circuits/${id}`);

export const getEquipmentTypes = () => get('/config/equipment-types');
export const createEquipmentType = (body) => post('/config/equipment-types', body);
export const updateEquipmentType = (id, body) => patch(`/config/equipment-types/${id}`, body);
export const deleteEquipmentType = (id) => remove(`/config/equipment-types/${id}`);

// Causes (request types of the equipment module)
export const getCauses = () => get('/config/causes');
export const createCause = (body) => post('/config/causes', body);
export const updateCause = (id, body) => patch(`/config/causes/${id}`, body);
export const deleteCause = (id) => remove(`/config/causes/${id}`);

// Departments
export const getDepartments = () => get('/config/departments');
export const createDepartment = (body) => post('/config/departments', body);
export const updateDepartment = (id, body) => patch(`/config/departments/${id}`, body);
export const replaceDepartment = (id, body) => post(`/config/departments/${id}/replace`, body);
export const deleteDepartment = (id) => remove(`/config/departments/${id}`);
// who approves a department's requests: its Șefs (none = the Șef of the nearest department above)
export const getHeadCandidates = () => get('/config/departments/head-candidates');
export const setDepartmentHeads = (id, userIds) => put(`/config/departments/${id}/heads`, { user_ids: userIds });

// Rooms
export const getLocations = () => get('/config/locations');
export const createLocation = (body) => post('/config/locations', body);
export const updateLocation = (id, body) => patch(`/config/locations/${id}`, body);
export const deleteLocation = (id) => remove(`/config/locations/${id}`);

// Model catalog, per equipment type
export const getCatalogKinds = (equipmentTypeId) => get('/peripherals/kinds', { equipmentTypeId });
export const createCatalogKind = (name, equipmentTypeId) => post('/peripherals/kinds', { name, equipment_type_id: equipmentTypeId });
export const updateCatalogKind = (id, name) => patch(`/peripherals/kinds/${id}`, { name });
export const deleteCatalogKind = (id) => remove(`/peripherals/kinds/${id}`);
export const getCatalogModels = (equipmentTypeId) => get('/peripherals/models', { equipmentTypeId });
export const createCatalogModel = (body) => post('/peripherals/models', body);
export const updateCatalogModel = (id, body) => patch(`/peripherals/models/${id}`, body);
export const deleteCatalogModel = (id) => remove(`/peripherals/models/${id}`);

// Log
export const getLog = (entity, limit) => get('/config/log', { entity: entity || undefined, limit });
